import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FileDown, Pencil } from "lucide-react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import ModificarEstadoPedidoModal from "./modificar-estado-pedido-modal";

export default function ModalMontoPagadoAConductor({
    isOpen,
    onClose,
    data = [],
    showToast,
    setProcessingVisible,
    onUpdateMontoPago = null,
    indexListaPedidos = null,
    onActualizarWorkFlowEnServer = null,
}) {
    const contentRef = useRef(null);
    const { t } = useTranslation();
    const [modificarEstadoPedidoOpen, setModificarEstadoPedidoOpen] = useState(false);
    const [modificarEstadoPedidoItem, setModificarEstadoPedidoItem] = useState(null);
    const [modificarIndexWorkflow, setModificarIndexWorkfow] = useState(null);
    const [displayData, setDisplayData] = useState(data);

    useEffect(() => {
        // console.log('ModalMontoPagadoAConductor data', data);
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            setDisplayData(data);
        }
    }, [isOpen, data]);

    useEffect(() => {
        if (!isOpen) {
            setModificarEstadoPedidoOpen(false);
            setModificarEstadoPedidoItem(null);
            setModificarIndexWorkfow(null);
        }
    }, [isOpen]);

    const obtenerTotalMonto = (data) => {
        try {
            // console.log('obtenerTotalMonto MontoDetalleModal', data);
            // let total = 0;
            let monto = 0;
            if (Array.isArray(data?.estadoPagoInfo)) {
                for (let i = 0; i < data.estadoPagoInfo.length; i++) {
                    const estadoPago = data.estadoPagoInfo[i];
                    if (Array.isArray(estadoPago.detalle)) {
                        for (let j = 0; j < estadoPago.detalle.length; j++) {
                            const detalle = estadoPago.detalle[j];
                            monto += Number(detalle?.monto);
                        }
                    }
                }
            }
            monto = monto.toFixed(2);
            return monto;
        } catch (err) {
            console.log('obtenerTotalMonto err');
            console.log(err);
            return null;
        }
    };

    const totalMonto = obtenerTotalMonto(displayData);

    const handleExportPdf = async () => {
        if (!contentRef.current) return;
        const el = contentRef.current;
        el.classList.add("modal-mpac-pdf-export");
        try {
            const canvas = await html2canvas(el, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: "#ffffff",
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "letter");
            const pageW = pdf.internal.pageSize.getWidth();
            const pageH = pdf.internal.pageSize.getHeight();
            const margin = 8;
            const w = pageW - margin * 2;
            const imgH = (canvas.height * w) / canvas.width;
            let heightLeft = imgH;
            let position = margin;
            pdf.addImage(imgData, "PNG", margin, position, w, imgH);
            heightLeft -= pageH;
            while (heightLeft > 0) {
                position = heightLeft - imgH + margin;
                pdf.addPage("p", "mm", "letter");
                pdf.addImage(imgData, "PNG", margin, position, w, imgH);
                heightLeft -= pageH;
            }
            pdf.save(`amount-paid-to-driver-${moment().format("YYYY-MM-DD-HHmm")}.pdf`);
        } catch (err) {
            console.warn("Export PDF err", err);
        } finally {
            el.classList.remove("modal-mpac-pdf-export");
        }
    };

    const renderDetallesTotales = (data) => {
        try {
            // console.log('renderDetallesTotales');
            // console.log(data);
            let arrayDetalle = [];
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                for (let j = 0; j < item.detalle.length; j++) {
                    const detalle = item.detalle[j];
                    // console.log('detalle');
                    // console.log(detalle);
                    if (arrayDetalle.length === 0) {
                        let objDetalle = {};
                        let monto = detalle.monto;
                        // console.log('monto', monto);
                        // console.log('isNaN(monto) === true', isNaN(monto) === true);
                        // console.log('typeof monto', typeof monto);
                        if (monto === null || isNaN(monto) === true) {
                            // console.log('monto isNaN');
                            monto = 0;
                        }
                        objDetalle.descripcion = detalle.descripcion;
                        objDetalle.monto = monto;
                        arrayDetalle.push(objDetalle);
                    } else {
                        const index = arrayDetalle.findIndex(item => item.descripcion === detalle.descripcion);
                        if (index !== -1) {
                            let monto = detalle.monto;
                            if (monto === null || isNaN(monto) === true) {
                                monto = 0;
                            }
                            arrayDetalle[index].monto += monto;
                        } else {
                            let objDetalle = {};
                            let monto = detalle.monto;
                            if (monto === null || isNaN(monto) === true) {
                                monto = 0;
                            }
                            objDetalle.descripcion = detalle.descripcion;
                            objDetalle.monto = monto;
                            arrayDetalle.push(objDetalle);
                        }
                    }
                }
            }
            return (
                <div>
                    {arrayDetalle.map((item, index) => (
                        <div key={index} className="flex items-end gap-2 text-sm w-full">
                            <span className="shrink-0">{item.descripcion}</span>
                            <span
                                className="flex-1 min-w-2 mb-1 border-b border-dotted border-gray-400"
                                aria-hidden="true"
                            />
                            <span className="shrink-0 tabular-nums">{item.monto}</span>
                        </div>
                    ))}
                </div>
            );
        } catch (err) {
            console.log('renderDetallesTotales err');
            console.log(err);
            return null;
        }
    };

    const handleModificarWorkFlow = (rowItem, rowIndex) => {
        try {
            // console.log('handleModificarWorkFlow');
            // console.log('rowItem', rowItem);
            // console.log('rowIndex', rowIndex);
            setModificarEstadoPedidoItem(rowItem);
            setModificarIndexWorkfow(rowIndex);
            setModificarEstadoPedidoOpen(true);
        } catch (err) {
            console.log("handleModificarWorkFlow err");
            console.log(err);
        }
    };

    const handleCloseModificarEstadoPedido = () => {
        setModificarEstadoPedidoOpen(false);
        setModificarEstadoPedidoItem(null);
        setModificarIndexWorkfow(null);
    };

    const handleModificarEstadoPedidoUpdateMontoPago = async (indexDetallePago, value, indexWorkflow) => {
        try {
            // console.log('handleModificarEstadoPedidoUpdate');
            // console.log('index', index);
            // console.log('value', value);
            if (typeof onUpdateMontoPago === "function") {
                onUpdateMontoPago(indexDetallePago, value, indexWorkflow, indexListaPedidos);
            }
        } catch (error) {
            console.log('handleModificarEstadoPedidoUpdate error');
            console.log(error);
        }
    };

    const renderTableBody = () => {
        try {
            return (

                displayData?.estadoPagoInfo.map((item, rowIndex) => {
                    // console.log('item');
                    // console.log(item);
                    // console.log('rowIndex');
                    // console.log(rowIndex);
                    // console.log('///////////////////////////////////////////////////////');
                    return (
                        <tr key={rowIndex} className="border-b border-gray-100 align-top last:border-b-0">
                            <td className="px-2 py-2 tabular-nums text-gray-800 whitespace-nowrap">
                                {rowIndex + 1}
                            </td>
                            <td className="px-2 py-2 text-gray-800">
                                <div className="font-medium text-gray-800">{item.descripcion}</div>
                                <div className="mt-0.5 text-gray-500 text-[10px] sm:hidden">
                                    {item.nombreCliente}
                                </div>
                                <div className="text-gray-500 text-[10px] sm:hidden">
                                    {item.numeroDocumento}
                                </div>
                            </td>
                            <td className="px-2 py-2 text-gray-700 hidden sm:table-cell">
                                {item.nombreCliente}
                            </td>
                            <td className="px-2 py-2 text-gray-600 hidden md:table-cell">
                                {item.numeroDocumento}
                            </td>
                            <td className="px-2 py-2">
                                <div className="flex flex-col gap-1 min-w-[8rem]">
                                    {item.detalle?.map((pago, pagoIndex) => (
                                        <div
                                            key={pagoIndex}
                                            className="flex justify-between gap-3 text-gray-600"
                                        >
                                            <span className="min-w-0 break-words">{pago.descripcion}</span>
                                            <span className="font-medium text-gray-900 tabular-nums shrink-0">
                                                {Number(pago.monto)}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </td>
                            <td className="modal-mpac-actions-col px-2 py-2 print:hidden">
                                <div className="flex items-center justify-center gap-1 sm:justify-end">
                                    <button
                                        type="button"
                                        className="inline-flex rounded-md p-1.5 text-blue-600 hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
                                        aria-label={t("column_modificar")}
                                        onClick={() => {
                                            handleModificarWorkFlow(item, rowIndex);
                                        }}
                                    >
                                        <Pencil className="h-4 w-4 sm:h-[18px] sm:w-[18px]" aria-hidden />
                                    </button>
                                    {/* Future: delete — <button type="button" aria-label={t("column_eliminar")}>…</button> */}
                                </div>
                            </td>
                        </tr>
                    );
                })

            );
        } catch (error) {
            console.log('renderTableBody error');
            console.log(error);
            return null;
        }
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="fixed inset-0 z-50 flex items-center justify-center">
                {/* <div className="bg-white rounded-lg  max-h-[500px] overflow-y-auto"> */}
                {/* Background overlay */}
                <div
                    className="absolute inset-0 bg-black bg-opacity-40"
                    onClick={onClose}
                />

                {/* Modal content */}
                <div className="relative bg-white rounded-lg shadow-lg w-[min(92vw,56rem)] sm:w-[85%] lg:w-[60%] max-w-[90%] p-4 sm:p-6 max-h-[500px] overflow-y-auto">
                    <div className="flex justify-between items-center">
                        <h2 className="text-lg font-semibold mb-4">
                            {t("label_detalle_monto_pagado_a_conductor")}
                        </h2>
                        <div className="flex items-center gap-2">
                            <button
                                type="button"
                                onClick={handleExportPdf}
                                className="flex items-center gap-2 px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-sm font-medium"
                            >
                                <FileDown className="h-4 w-4" />
                                {t("label_exportar_pdf")}
                            </button>
                        </div>
                    </div>

                    <style>{`
                    .modal-mpac-pdf-export .modal-mpac-actions-col {
                        display: none !important;
                    }
                `}</style>
                    <div
                        ref={contentRef}
                        className="bg-white text-black"
                        style={{
                            fontFamily: "sans-serif",
                            fontSize: "12px"
                        }}
                    >
                        <div className="w-full">
                            {displayData?.estadoPagoInfo.length === 0 ? (
                                <p className="text-gray-500 text-sm">
                                    {t("label_no_hay_informacion_disponible")}
                                </p>
                            ) : (
                                <div>
                                    {/* Block-level lines + spacing: html2canvas often clips inline line boxes against the next sibling */}
                                    <div className="mb-4 space-y-1.5 text-gray-700 font-semibold leading-normal">
                                        <div className="block min-h-[1.5em] py-px">
                                            {t("label_fecha")}:{moment(displayData?.fecha).format("YYYY/MM/DD")}
                                        </div>
                                        <div className="block min-h-[1.5em] py-px">
                                            {t("label_placa")}:{displayData?.labelPlaca}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="w-full overflow-x-auto rounded-lg border border-gray-200 touch-pan-x">
                                            <table className="w-full min-w-[36rem] sm:min-w-[42rem] border-collapse text-left text-[11px] sm:text-sm">
                                                <thead>
                                                    <tr className="border-b border-gray-200 bg-gray-50">
                                                        <th scope="col" className="px-2 py-2 font-semibold text-gray-700 whitespace-nowrap w-10">
                                                            {t("column_nro")}
                                                        </th>
                                                        <th scope="col" className="px-2 py-2 font-semibold text-gray-700 min-w-[7rem]">
                                                            {t("column_descripcion")}
                                                        </th>
                                                        <th scope="col" className="px-2 py-2 font-semibold text-gray-700 min-w-[6rem] hidden sm:table-cell">
                                                            {t("column_nombre_cliente")}
                                                        </th>
                                                        <th scope="col" className="px-2 py-2 font-semibold text-gray-700 min-w-[5rem] hidden md:table-cell">
                                                            {t("column_numero_documento")}
                                                        </th>
                                                        <th scope="col" className="px-2 py-2 font-semibold text-gray-700 min-w-[9rem]">
                                                            {t("label_detalle_pagos")}
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="modal-mpac-actions-col px-2 py-2 font-semibold text-gray-700 text-center whitespace-nowrap w-24 print:hidden"
                                                        >
                                                            {t("column_acciones")}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {renderTableBody()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {Array.isArray(displayData?.estadoPagoInfo) &&
                            <div>
                                <span className="text-gray-700 font-semibold">{t("label_detalles_totales")}</span>
                                {renderDetallesTotales(displayData.estadoPagoInfo)}
                            </div>
                        }

                        {/* Total */}
                        {displayData?.estadoPagoInfo.length > 0 && (
                            <div className="flex justify-between mt-4 pt-3 border-t font-semibold">
                                <span>{t("label_total")}</span>
                                <span>{totalMonto}</span>
                            </div>
                        )}
                        <div className="flex justify-end mt-6">

                        </div>
                    </div>

                    {/* Close button */}
                    <div className="flex justify-end mt-6">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
                        >
                            {t("label_cerrar")}
                        </button>
                    </div>
                </div>
            </div>

            <ModificarEstadoPedidoModal
                isOpen={modificarEstadoPedidoOpen}
                onClose={handleCloseModificarEstadoPedido}
                item={modificarEstadoPedidoItem}
                parentData={displayData}
                showToast={showToast}
                setProcessingVisible={setProcessingVisible}
                indexWorkflow={modificarIndexWorkflow}
                onUpdateMontoPago={handleModificarEstadoPedidoUpdateMontoPago}
                onActualizarWorkFlowEnServer={() => {
                    console.log('onActualizarWorkFlowEnServer');
                    onActualizarWorkFlowEnServer(modificarIndexWorkflow);
                }}
            />
        </>
    );
}
